<template>
  <div>
    <div class="zn-template-head">
      <span class="zn-template-title">1 3 7 详解</span>
    </div>
    <div class="zn-template-content" ref="tplContent">
      <div style="border:1px solid #eee;border-radius:4px;padding:10px;line-height:2;margin-top:10px">
        <div style="color:#999">注解：1、3、7 的意思分别为建项后 第1天、第3天、第7天三个时间节点我们需要做的事情及工作节奏</div>
        <div>
          第一天：项目当天必须出人有效推荐（完成一键匹配人选的沟通），如果当天没出人，客户经理可以让别人接手<br/>
          第三天：3天出具初步项目小结（八股文）<br/>
          第七天：7天核心领域出完整市场报告，推荐覆盖市场100%
        </div>
      </div>
      <div style="color:#F56C6C;line-height:1.5;padding:5px">
        <div style="padding-top:10px">
          <i class="el-icon-warning"></i>
          推荐人选一直没有反馈时，承做顾问和项目经理要给足客户经理子弹，梳理清楚331，不断推动客户经理要反馈
        </div>
        <div style="padding-top:10px">
          <i class="el-icon-warning"></i>
          岗位一周没有反馈，询问是否有隐藏原因：<br>
          1、业务战略层面：业务是否发生调整导致该岗位靠谱程度发生变化<br>
          2、面试流程上的人：面试领导的问题，面试了多少人，领导去了哪里？流程里其他候选人怎么样了？
        </div>
      </div>
      <div style="border:1px solid #eee;border-radius:4px;padding:10px;line-height:2;margin-top:10px">
        <div style="margin-bottom:15px 0">市场报告模版：<span class="a-link" @click="preview('b7f028aeaf4d7ae8de783201f4f83a2b')">阿尔法市场报告模版.xlsx</span></div>
        <div>项目小结（八股文）模版：<span class="a-link" @click="preview('4c5088ef869763c8324c24f52089ea95')">项目小结文字版本（邮件正文）.docx</span></div>
        <div style="padding:10px 20px;line-height:1.5;color:#666">
          关于【客户公司】的【岗位名称】的职位，我们搜寻了【待沟通人选公司数目】家【公募/券商】：【待沟通人选公司】
          <br/><br/>
          我们重点沟通了符合岗位要求的【年资】、【职级】【岗位名称】人选，沟通相关人选【待沟通人选数目】人，合适人选【沟通了的人选数目】人，推荐【真实推荐人选数目】人，目前【点了推荐 — 已发推报实际推荐】人跟进中。
          <br/><br/>
          人选不考虑的原因：
          <br/>
          参考模版：
          <br/>
          1）各家 ｛①做【岗位名称】的人选  ②Base【地点】的人选 ③年资符合条件的人选｝较少
          <br/>
          2）认为公司的发展前景不明确；
          <br/>
          3）认为公司对该业务板块投入力度较小；
          <br/>
          4）认为公司薪酬激励不够市场化；
          <br/>
          5）认为公司近期市场传闻比较动荡
          <br/><br/>
          接下来我们会进一步寻访【寻访方向】
          <br/><br/>
          已推荐【推荐量】人，【推荐人选1】,【推荐人选2】。
          <br/>
          【推荐人选1】：
          <br/>
          【推荐概述】
          <br/>
          【推荐人选2】
          <br/>
          【推荐概述】
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    async preview(md5) {
      const ref = app.root.$refs.cvPreview
      if (!ref) return
      ref.getFile({ md5 })
      ref.show()
    },
  }
}
</script>
